var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showCompareContent
    ? _c("div", { staticStyle: { "content-visibility": "hidden" } }, [
        _c(
          "div",
          { staticClass: "container-fluid", attrs: { id: "outer-wrapper" } },
          [
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.getCompareProducts, function(item) {
                return _c(
                  "div",
                  { key: item.styleNumber, staticClass: "col-md-3" },
                  [
                    _c("div", [
                      _c("div", { staticClass: "compare-div-part mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "pop-up-compare-div-image mb-3" },
                          [
                            _c("img", {
                              staticClass: "w-100",
                              attrs: {
                                alt: item.colors[0].colorNumber,
                                src:
                                  item.colors[0].imagePath != "null" &&
                                  item.colors[0].imagePath != null
                                    ? item.colors[0].imagePath.includes("?")
                                      ? item.colors[0].imagePath + "&"
                                      : item.colors[0].imagePath + "?"
                                    : "",
                                crossOrigin: "anonymous"
                              },
                              on: { error: _vm.handleImageError }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _c("div", [
                              _c("dt", [
                                _c("u", [
                                  _vm._v(_vm._s(item.colors[0].colorName))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.colors[0].colorNumber) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("dt", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.style"
                                      ]
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.sellingStyleName) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("dt", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.collection"
                                      ]
                                    ) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.collection) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "swatches-part" }, [
                              _c(
                                "p",
                                { staticClass: "swatch-title text-uppercase" },
                                [
                                  _c("b", [_vm._v(_vm._s(item.colors.length))]),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.room.scene.swatch.colors"
                                        ]
                                      ) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(item.colors, function(color) {
                                  return _c(
                                    "div",
                                    {
                                      key: color.colorName + color.colorNumber,
                                      staticClass: "col-4"
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "w-100",
                                        attrs: {
                                          crossOrigin: "anonymous",
                                          src:
                                            color.imagePath != "null" &&
                                            color.imagePath != null
                                              ? color.imagePath.includes("?")
                                                ? color.imagePath + "&"
                                                : color.imagePath + "?"
                                              : "",
                                          alt: ""
                                        },
                                        on: { error: _vm.handleImageError }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "wf-product-room-scene-color-item-name"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(color.colorName)
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(color.colorNumber) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "specification-part" }, [
                                _c("h3", { staticClass: "label my-2" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.specifications.specifications"
                                        ]
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {}, [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.product.category"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.inventorySubType) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.product.category"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.inventorySubType) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.product.type"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.inventoryType) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.secondary.backing"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.secondaryBacking) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.construction"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.construction) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.wear.rating"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          item.testResults.tarrClassification
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.dye.method"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.dyeMethod) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("dt", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.fiber"
                                          ]
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(item.fiber) +
                                        "\n                    "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                item.areaPerCarton
                                  ? _c("div", [
                                      _c("dt", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "product.details.specifications.squareyards"
                                              ]
                                            ) +
                                            "\n                    "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("dd", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              Math.round(
                                                item.areaPerCarton.metric
                                                  .formattedValue * 100
                                              ) / 100
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "pdq-part" }, [
                                _c("h3", { staticClass: "label my-2" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.specifications.pdq.details"
                                        ]
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("dt", {
                                  staticClass: "pdq-name text-uppercase",
                                  domProps: {
                                    innerHTML: _vm._s(item.pdqDetails)
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sustain-part mb-3" }, [
                                _c("h3", { staticClass: "label my-2" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.specifications.sustainability"
                                        ]
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("dt", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.specifications.recyclability"
                                        ]
                                      ) +
                                      "\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("dd", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.recyclability) +
                                      "\n                  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "third-party-part" },
                                [
                                  _c("h3", { staticClass: "label my-2" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$resourceString[
                                            "product.details.specifications.third.party.certificates"
                                          ]
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(item.attributes, function(attribute) {
                                    return item.attributes.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            key: attribute.name,
                                            staticClass:
                                              "third-party-items mb-2"
                                          },
                                          [
                                            attribute.pdfLink
                                              ? _c("dt", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(attribute.name) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            attribute.pdfLink
                                              ? _c("dd", [
                                                  _c("u", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          attribute.status
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  _vm._v(" "),
                                  _vm._l(item.certifications, function(
                                    certification
                                  ) {
                                    return item.certifications.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            key: certification.name,
                                            staticClass:
                                              "third-party-items mb-2"
                                          },
                                          [
                                            certification.pdfLink
                                              ? _c("dt", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        certification.name
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            certification.pdfLink
                                              ? _c("dd", [
                                                  _c("u", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          certification.status
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }